'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** ../~/react/react.js
 ** module id = 2
 ** module chunks = 3
 **/